<template>
  <div>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>

    <v-dialog v-model="tahsilatdialog" persistent max-width="700px">
      <v-card color="grey lighten-5">
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title class="baslikfont">{{
              dialogbaslik
            }}</v-toolbar-title>
          </v-toolbar>
        </v-flex>
        <v-card-text>
          <v-layout row wrap v-if="tahsilatguncellebuton">
            <v-flex xs12 pb-2 sm12 md12>
              <v-flex xs12 sm12 md12>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md1>
                    <v-layout align-center fill-height row wrap>
                      <v-chip
                        v-if="itemsodeme[0].SaticiTip == 1"
                        small=""
                        color="white"
                        text-color="pink"
                      >
                        <v-icon color="pink">hotel</v-icon>
                      </v-chip>

                      <v-chip
                        v-if="itemsodeme[0].SaticiTip == 2"
                        small=""
                        color="orange"
                        text-color="white"
                      >
                        <v-icon color="white">rv_hookup</v-icon>
                      </v-chip>

                      <v-chip
                        v-if="itemsodeme[0].SaticiTip == 3"
                        small=""
                        color="deep-purple"
                        text-color="white"
                      >
                        <v-icon color="white">restaurant</v-icon>
                      </v-chip>

                      <v-chip
                        v-if="itemsodeme[0].SaticiTip == 4"
                        small=""
                        color="yellow accent-4"
                        text-color="white"
                      >
                        <v-icon color="white">local_see</v-icon>
                      </v-chip>

                      <v-chip
                        v-if="itemsodeme[0].SaticiTip == 5"
                        small=""
                        color="green"
                        text-color="white"
                      >
                        <v-icon color="white">departure_board</v-icon>
                      </v-chip>

                      <v-chip
                        v-if="itemsodeme[0].SaticiTip == 6"
                        small=""
                        color="teal accent-4"
                        text-color="white"
                      >
                        <v-icon color="white">emoji_people</v-icon>
                      </v-chip>

                      <v-chip
                        v-if="itemsodeme[0].SaticiTip == 7"
                        small=""
                        color="orange"
                        text-color="white"
                      >
                        <v-icon color="white">museum</v-icon>
                      </v-chip>

                      <v-chip
                        v-if="itemsodeme[0].SaticiTip == 8"
                        small=""
                        color="blue darken-4"
                        text-color="white"
                      >
                        <v-icon color="white">flight_takeoff</v-icon>
                      </v-chip>

                      <v-chip
                        v-if="itemsodeme[0].SaticiTip == 9"
                        small=""
                        color="cyan darken-2"
                        text-color="white"
                      >
                        <v-icon color="white">directions_boat</v-icon>
                      </v-chip>

                      <v-chip
                        v-if="itemsodeme[0].SaticiTip == 10"
                        small=""
                        color="pink"
                        text-color="white"
                      >
                        <v-icon color="white">category</v-icon>
                      </v-chip>

                      <v-chip
                        v-if="itemsodeme[0].SaticiTip == 11"
                        small=""
                        color="brown"
                        text-color="white"
                      >
                        <v-icon color="white">style</v-icon>
                      </v-chip>

                      <v-chip
                        v-if="itemsodeme[0].SaticiTip == 12"
                        small=""
                        color="deep-purple"
                        text-color="white"
                      >
                        <v-icon color="white">style</v-icon>
                      </v-chip>

                      <v-chip
                        v-if="itemsodeme[0].SaticiTip == 13"
                        small=""
                        color="info"
                        text-color="white"
                      >
                        <v-icon color="white">style</v-icon>
                      </v-chip>

                      <v-chip
                        v-if="itemsodeme[0].SaticiTip == 14"
                        small=""
                        color="lime"
                        text-color="white"
                      >
                        <v-icon color="white">verified_user</v-icon>
                      </v-chip>

                      <v-chip
                        v-if="itemsodeme[0].SaticiTip == 15"
                        small=""
                        color="blue"
                        text-color="white"
                      >
                        <v-icon color="white">directions_boat</v-icon>
                      </v-chip>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md3>
                    <v-layout align-center fill-height row wrap>
                      <v-flex xs12 sm12 md12>
                        <span class="grey--text body-1">
                          {{ itemsodeme[0].Satici.isim }}
                        </span>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <span class="grey--text body-1">
                          {{ itemsodeme[0].TurOperatoru.isim }}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md3>
                    <v-layout row justify-center align-center fill-height wrap>
                      <v-flex xs12 sm12 md12>
                        <span class="grey--text body-1">
                          {{ itemsodeme[0].Donem1 | dateformat }}
                        </span>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <span class="grey--text body-1">
                          {{ itemsodeme[0].Donem2 | dateformat }}
                        </span>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 md3>
                    <v-layout row justify-center align-center fill-height wrap>
                      <v-flex xs12 sm12 md12>
                        <v-layout row justify-center fill-height wrap>
                          <v-icon color="red" small>person</v-icon> &nbsp;
                          <span class="body-1 grey--text">
                            {{ itemsodeme[0].KisiIsim }}
                          </span>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 sm12 pr-2 md2>
                    <v-layout row align-center fill-height justify-end wrap>
                      <span class="grey--text body-1">
                        {{ itemsodeme[0].KalemMaliyet | moneyformat }}
                        {{ para.paraBirimi }}</span
                      >
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-flex>
          </v-layout>
          <v-form ref="formTahsilat" v-model="valid" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12 pb-2 sm12 md12 v-if="!tahsilatguncellebuton">
                <v-select
                  hide-details
                  :rules="[
                    (v) => !!v.PNR_No || $t('Code-cannot-left-blank'),
                    (v) => v.PNR_No != '0' || 'Kod tanımlanmamış.',
                  ]"
                  :items="itemsodeme"
                  v-model="kalemdata"
                  label="Kalem Seçimi"
                >
                  <template slot="selection" slot-scope="{ item }">
                    <v-flex xs12 sm12 md12>
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md2>
                          <v-layout align-center fill-height row wrap>
                            <v-chip
                              v-if="item.SaticiTip == 1"
                              small=""
                              color="white"
                              text-color="pink"
                            >
                              <v-icon color="pink">hotel</v-icon>
                            </v-chip>

                            <v-chip
                              v-if="item.SaticiTip == 2"
                              small=""
                              color="orange"
                              text-color="white"
                            >
                              <v-icon color="white">rv_hookup</v-icon>
                            </v-chip>

                            <v-chip
                              v-if="item.SaticiTip == 3"
                              small=""
                              color="deep-purple"
                              text-color="white"
                            >
                              <v-icon color="white">restaurant</v-icon>
                            </v-chip>

                            <v-chip
                              v-if="item.SaticiTip == 4"
                              small=""
                              color="yellow accent-4"
                              text-color="white"
                            >
                              <v-icon color="white">local_see</v-icon>
                            </v-chip>

                            <v-chip
                              v-if="item.SaticiTip == 5"
                              small=""
                              color="green"
                              text-color="white"
                            >
                              <v-icon color="white">departure_board</v-icon>
                            </v-chip>

                            <v-chip
                              v-if="item.SaticiTip == 6"
                              small=""
                              color="teal accent-4"
                              text-color="white"
                            >
                              <v-icon color="white">emoji_people</v-icon>
                            </v-chip>

                            <v-chip
                              v-if="item.SaticiTip == 7"
                              small=""
                              color="orange"
                              text-color="white"
                            >
                              <v-icon color="white">museum</v-icon>
                            </v-chip>

                            <v-chip
                              v-if="item.SaticiTip == 8"
                              small=""
                              color="blue darken-4"
                              text-color="white"
                            >
                              <v-icon color="white">flight_takeoff</v-icon>
                            </v-chip>

                            <v-chip
                              v-if="item.SaticiTip == 9"
                              small=""
                              color="cyan darken-2"
                              text-color="white"
                            >
                              <v-icon color="white">directions_boat</v-icon>
                            </v-chip>

                            <v-chip
                              v-if="item.SaticiTip == 10"
                              small=""
                              color="pink"
                              text-color="white"
                            >
                              <v-icon color="white">category</v-icon>
                            </v-chip>

                            <v-chip
                              v-if="item.SaticiTip == 11"
                              small=""
                              color="brown"
                              text-color="white"
                            >
                              <v-icon color="white">style</v-icon>
                            </v-chip>

                            <v-chip
                              v-if="item.SaticiTip == 12"
                              small=""
                              color="deep-purple"
                              text-color="white"
                            >
                              <v-icon color="white">style</v-icon>
                            </v-chip>

                            <v-chip
                              v-if="item.SaticiTip == 13"
                              small=""
                              color="info"
                              text-color="white"
                            >
                              <v-icon color="white">style</v-icon>
                            </v-chip>

                            <v-chip
                              v-if="item.SaticiTip == 14"
                              small=""
                              color="lime"
                              text-color="white"
                            >
                              <v-icon color="white">verified_user</v-icon>
                            </v-chip>

                            <v-chip
                              v-if="item.SaticiTip == 15"
                              small=""
                              color="blue"
                              text-color="white"
                            >
                              <v-icon color="white">directions_boat</v-icon>
                            </v-chip>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm12 md3>
                          <v-layout align-center fill-height row wrap>
                            <v-flex xs12 sm12 md12>
                              <span class="grey--text body-1">
                                {{ item.Satici.isim }}
                              </span>
                            </v-flex>
                            <v-flex>
                              <span class="grey--text body-1">
                                <!-- {{ item.TurOperatoru.kod }} -->
                              </span>
                            </v-flex>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm12 md3>
                          <v-layout
                            row
                            justify-center
                            align-center
                            fill-height
                            wrap
                          >
                            <v-flex xs12 sm12 md12>
                              <span class="grey--text body-1">
                                {{ item.Donem1 | dateformat }}
                              </span>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <span class="grey--text body-1">
                                {{ item.Donem2 | dateformat }}
                              </span>
                            </v-flex>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm12 md2>
                          <v-layout
                            row
                            justify-center
                            align-center
                            fill-height
                            wrap
                          >
                            <v-flex xs12 sm12 md12>
                              <v-layout row justify-center fill-height wrap>
                                <v-icon color="red" small>person</v-icon> &nbsp;
                                <span class="body-1 grey--text">
                                  {{ item.KisiIsim }}
                                </span>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm12 pr-2 md2>
                          <v-layout
                            row
                            align-center
                            fill-height
                            justify-end
                            wrap
                          >
                            <span class="grey--text body-1">
                              {{ item.KalemMaliyet | moneyformat }}
                              {{ para.paraBirimi }}</span
                            >
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </template>

                  <template slot="item" slot-scope="data">
                    <v-layout row wrap>
                      <v-flex xs12 pr-2 sm12 md1>
                        <v-layout align-center fill-height row wrap>
                          <v-chip
                            v-if="data.item.Satici.tip == 1"
                            small=""
                            color="white"
                            text-color="pink"
                          >
                            <v-icon color="pink">hotel</v-icon>
                          </v-chip>

                          <v-chip
                            v-if="data.item.Satici.tip == 2"
                            small=""
                            color="orange"
                            text-color="white"
                          >
                            <v-icon color="white">rv_hookup</v-icon>
                          </v-chip>

                          <v-chip
                            v-if="data.item.Satici.tip == 3"
                            small=""
                            color="deep-purple"
                            text-color="white"
                          >
                            <v-icon color="white">restaurant</v-icon>
                          </v-chip>

                          <v-chip
                            v-if="data.item.Satici.tip == 4"
                            small=""
                            color="yellow accent-4"
                            text-color="white"
                          >
                            <v-icon color="white">local_see</v-icon>
                          </v-chip>

                          <v-chip
                            v-if="data.item.Satici.tip == 5"
                            small=""
                            color="green"
                            text-color="white"
                          >
                            <v-icon color="white">departure_board</v-icon>
                          </v-chip>

                          <v-chip
                            v-if="data.item.Satici.tip == 6"
                            small=""
                            color="teal accent-4"
                            text-color="white"
                          >
                            <v-icon color="white">emoji_people</v-icon>
                          </v-chip>

                          <v-chip
                            v-if="data.item.Satici.tip == 7"
                            small=""
                            color="orange"
                            text-color="white"
                          >
                            <v-icon color="white">museum</v-icon>
                          </v-chip>

                          <v-chip
                            v-if="data.item.Satici.tip == 8"
                            small=""
                            color="blue darken-4"
                            text-color="white"
                          >
                            <v-icon color="white">flight_takeoff</v-icon>
                          </v-chip>

                          <v-chip
                            v-if="data.item.Satici.tip == 9"
                            small=""
                            color="cyan darken-2"
                            text-color="white"
                          >
                            <v-icon color="white">directions_boat</v-icon>
                          </v-chip>

                          <v-chip
                            v-if="data.item.Satici.tip == 10"
                            small=""
                            color="pink"
                            text-color="white"
                          >
                            <v-icon color="white">category</v-icon>
                          </v-chip>

                          <v-chip
                            v-if="data.item.Satici.tip == 11"
                            small=""
                            color="brown"
                            text-color="white"
                          >
                            <v-icon color="white">style</v-icon>
                          </v-chip>

                          <v-chip
                            v-if="data.item.Satici.tip == 12"
                            small=""
                            color="deep-purple"
                            text-color="white"
                          >
                            <v-icon color="white">style</v-icon>
                          </v-chip>

                          <v-chip
                            v-if="data.item.Satici.tip == 13"
                            small=""
                            color="info"
                            text-color="white"
                          >
                            <v-icon color="white">style</v-icon>
                          </v-chip>

                          <v-chip
                            v-if="data.item.Satici.tip == 14"
                            small=""
                            color="lime"
                            text-color="white"
                          >
                            <v-icon color="white">verified_user</v-icon>
                          </v-chip>

                          <v-chip
                            v-if="data.item.Satici.tip == 15"
                            small=""
                            color="blue"
                            text-color="white"
                          >
                            <v-icon color="white">directions_boat</v-icon>
                          </v-chip>
                        </v-layout>
                      </v-flex>

                      <v-flex xs12 pr-2 sm12 md2>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12>
                            <span class="grey--text caption">
                              {{ data.item.Satici.isim }}
                            </span>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <span class="grey--text caption">
                              {{ data.item.TurOperatoru.kod }}
                            </span>
                          </v-flex>
                        </v-layout>
                      </v-flex>

                      <v-flex pl-2 xs12 sm12 md2>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12>
                            <span class="caption">
                              {{ data.item.Donem1 | dateformat }}
                            </span>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <span class="caption">
                              {{ data.item.Donem2 | dateformat }}</span
                            >
                          </v-flex>
                        </v-layout>
                      </v-flex>

                      <v-flex pl-1 xs12 sm12 md3>
                        <v-layout row wrap>
                          <v-flex xs12 sm6 md6>
                            <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                <span class="caption"> {{ $t('Amount') }} : </span>
                              </v-flex>

                              <v-flex xs12 sm12 md12>
                                <span class="caption"> {{$t('Currency-Amount')}}:</span>
                              </v-flex>
                            </v-layout>
                          </v-flex>

                          <v-flex xs12 sm6 md6>
                            <v-layout row align-end fill-height wrap>
                              <v-flex xs12 sm12 md12>
                                <v-layout
                                  row
                                  align-end
                                  fill-height
                                  justify-end
                                  column
                                  wrap
                                >
                                  <span class="caption">
                                    {{ data.item.KalemMaliyet | moneyformat }}
                                    {{ para.paraBirimi }}
                                  </span>
                                </v-layout>
                              </v-flex>

                              <v-flex xs12 sm12 md12>
                                <v-layout
                                  row
                                  align-end
                                  fill-height
                                  justify-end
                                  column
                                  wrap
                                >
                                  <span class="caption">
                                    {{ data.item.MaliyetDoviz | moneyformat }}
                                    {{ data.item.MaliyetParaBirimi }}</span
                                  >
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>

                      <v-flex pl-1 xs12 sm12 md2>
                        <v-layout row justify-center align-end fill-height wrap>
                          <v-flex xs12 sm12 md12>
                            <v-layout
                              row
                              justify-center
                              align-end
                              fill-height
                              wrap
                            >
                              <span class="caption">
                                {{ $t("Currentcode_label") }}</span
                              >
                            </v-layout>
                          </v-flex>
                          <v-flex
                            v-if="
                              data.item.TurOperatoru.kod == null ||
                              data.item.TurOperatoru.kod == ''
                            "
                            xs12
                            sm12
                            md12
                          >
                            <v-layout
                              row
                              justify-center
                              align-end
                              fill-height
                              wrap
                            >
                              <span class="caption">
                                {{ data.item.Satici.CariKod }}
                              </span>
                            </v-layout>
                          </v-flex>
                          <v-flex
                            v-if="
                              data.item.TurOperatoru.kod != null ||
                              data.item.TurOperatoru.kod != ''
                            "
                            xs12
                            sm12
                            md12
                          >
                            <v-layout
                              row
                              justify-center
                              align-end
                              fill-height
                              wrap
                            >
                              <span class="caption">
                                {{ data.item.TurOperatoru.CariKod }}
                              </span>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>

                      <v-flex pl-1 xs12 sm12 md2>
                        <v-layout
                          row
                          justify-center
                          align-center
                          fill-height
                          wrap
                        >
                          <v-flex xs12 sm12 md12>
                            <v-layout row justify-center fill-height wrap>
                              <v-icon color="red" small>person</v-icon>
                              <span class="caption">
                                {{ data.item.KisiIsim }}
                              </span>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </template>
                </v-select>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <tarihcomp
                  :etiket="$t('Payment-Date')"
                  :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                  v-bind:defaultvalue="'ok'"
                  v-bind:value="odeme.OdemeTarihi"
                  v-model="odeme.OdemeTarihi"
                ></tarihcomp>
              </v-flex>

              <v-flex sm6 md6 xs6>
                <v-select
                  hide-details
                  item-text="text"
                  item-value="value"
                  :label="$t('Payment-Type')"
                  v-model="odeme.OdemeTipi"
                  :items="odemeItems"
                ></v-select>
              </v-flex>

              <v-flex sm12 md12 xs12>
                <kurcomp
                  :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                  v-model="para"
                  :kurtarihi="odeme.OdemeTarihi"
                ></kurcomp>
              </v-flex>

              <!-- <v-flex sm12 md12 xs12>
                <kur :rules="[v => !!v || 'Gerekli alan']" v-model="para" :kurtarihi="odeme.OdemeTarihi"></kur>
              </v-flex> -->

              <v-flex sm12 md12 xs12>
                <parainput
                  :etiket="'Tutar'"
                  :simge="getparabirimi()"
                  v-model="odeme.Tutar"
                  :autocomplete="'autocomplete'"
                ></parainput>
              </v-flex>

              <v-flex sm12 md12 xs12>
                <!-- <v-form ref="formkarsicari" v-model="validkarsicari" lazy-validation> -->
                <v-layout row wrap>
                  <v-flex sm12 md12 xs12>
                    <cariaracomp
                      v-if="
                        odeme.OdemeTipi == 0 ||
                        odeme.OdemeTipi == 3 ||
                        odeme.OdemeTipi == 1
                      "
                      v-bind:etiket="'Karşı Cari '"
                      v-bind:value="cariKodu.KarsiCari.kod"
                      v-model="cariKodu.KarsiCari.kod"
                      :Coper="true"
                    ></cariaracomp>
                  </v-flex>
                  <v-flex sm12 md12 xs12>
                    <v-text-field
                      hide-details=""
                      v-if="
                        odeme.OdemeTipi == 0 ||
                        odeme.OdemeTipi == 3 ||
                        odeme.OdemeTipi == 1
                      "
                      v-model="cariKodu.KarsiCariAciklama"
                      :rules="[
                        (v) =>
                          v == null ||
                          v.length <= 250 ||
                          'Max 250 karakter olmalı',
                      ]"
                      :label="$t('Counter-Explanation')"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <!-- </v-form> -->
              </v-flex>

              <v-flex sm12 md12 xs12>
                <v-form
                  ref="formkredikarti"
                  v-model="validkredikarti"
                  lazy-validation
                >
                  <v-layout row wrap>
                    <v-flex sm12 md12 xs12>
                      <firmakarticomp
                        v-if="odeme.OdemeTipi == 1"
                        :rules="[
                          (v) =>
                            v == null ||
                            v.length <= 20 ||
                            'Max 20 karakter olmalı',
                        ]"
                        v-model="odeme.KrediKartBilgi.KartNo"
                      ></firmakarticomp>
                    </v-flex>
                   
                    <v-flex sm12 md12 xs12>
                      <v-select
                        hide-details
                        :items="karttipi"
                        v-if="odeme.OdemeTipi == 1"
                        clearable
                        v-model="odeme.KrediKartBilgi.KartTipi"
                        :label="$t('Credit-Card-Type-v2')"
                        item-text="text"
                        item-value="id"
                      ></v-select>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>

              <v-flex v-if="odeme.OdemeTipi == 2" sm12 md12 xs12>
                <!-- <v-form ref="formhavale" v-model="validhavale" lazy-validation> -->
                <v-layout row wrap>
                  <v-flex sm12 md12 xs12>
                    <v-autocomplete
                      :items="itemsbanka"
                      hide-details=""
                      v-model="odeme.HavaleBilgi.Banka"
                      item-text="BankaAdi"
                      item-value="BankaKod"
                      clearable
                      :label="$t('Bank-Code')"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex sm12 md12 xs12>
                    <v-text-field
                      hide-details=""
                      v-model="odeme.HavaleBilgi.Aciklama"
                      :rules="[
                        (v) =>
                          v == null ||
                          v.length <= 100 ||
                          $t('Must-be-characters-maximum-v2'),
                      ]"
                      :label="$t('Transfer-Explanation')"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <!-- </v-form> -->
              </v-flex>

              <v-flex sm12 md12 xs12>
                <v-text-field
                  hide-details=""
                  v-model="odeme.Aciklama"
                  :rules="[
                    (v) =>
                      v == null || v.length <= 250 || 'Max 250 karakter olmalı',
                  ]"
                  :label="$t('Description')"
                >
                </v-text-field>
              </v-flex>
              <v-flex sm12 md12 v-if="odeme.OdemeTipi == 1" xs6>
                <v-checkbox
                  hide-details
                  :label="$t('Corporate-Credit-Card-v2')"
                  v-model="odeme.KrediKartBilgi.FirmaKrediKartli"
                >
                </v-checkbox>
              </v-flex>
              <v-checkbox
                :label="$t('Payment-Return')"
                v-model="odeme.SaticiOdemeIadesi"
              ></v-checkbox>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="blue darken-1"
            flat
            @click.native="tahsilatdialog = false"
            >{{$t('Cancel')}}</v-btn
          >
          <div v-show="tahsilatguncellebuton === true">
            <v-btn
              id="bguncelle"
              color="blue darken-1"
              flat
              @click="tahsilatguncelle()"
              >{{ $t('Update') }}</v-btn
            >
          </div>
          <div v-show="kaydetbuton === true">
            <v-btn
              id="bkaydet"
              :disabled="disabledtest"
              color="blue darken-1"
              flat
              @click="delaytest"
              >{{ $t("save_button") }}</v-btn
            >
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card>
      <v-snackbar
        :timeout="timeoutSnackbar"
        :top="y === 'top'"
        :bottom="y === 'bottom'"
        :right="x === 'right'"
        :left="x === 'left'"
        :multi-line="mode === 'multi-line'"
        :vertical="mode === 'vertical'"
        v-model="snackbar"
      >
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>
    </v-card>
  </div>
</template>


<script>
import auth from "../../../../api/auth";
import tarihcomp from "../../customcomp/tarihim";
import parainput from "@/components/app/customcomp/parainput.vue";
import dovizinput from "@/components/app/customcomp/dovizinput.vue";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import helpers from "@/components/app/customcomp/helpers.js";
import rez from "../rezervasyon";
import kur from "@/components/app/coper/comp/kur.vue";
import tool from "../tools";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import kurcomp from "@/components/app/coper/component/kurcomp.vue";
import firmakarticomp from "@/components/app/coper/component/firmakarticomp.vue";
import cariaracomp from "@/components/app/customcomp/cariaracomp.vue";

export default {
  props: ["value"],
  components: {
    tarihcomp,
    parainput,
    dovizinput,
    kur,
    genelarama,
    loadingcomp,
    kurcomp,
    firmakarticomp,
    cariaracomp,
  },
  computed: {
    val: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  beforeMount: beforeMount,
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },
    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
    getdefaultparabirimi: function (m) {
      return helpers.getparabirimiDefault(m);
    },
  },
  beforeDestroy() {
    // clear the timeout before the component is destroyed
    clearTimeout(this.timeout);
  },
  methods: {
    delaytest() {
      this.disabledtest = true;

      // Re-enable after 5 seconds
      this.timeout = setTimeout(() => {
        this.disabledtest = false;
      }, 5000);

      this.tahsilatvalidate();
    },
    PNRKalemList() {
      let params = {
        Tip: 1,
        Id: this.PnrNo,
        ParaBirimi: this.para.paraBirimi,
      };

      tool.http_post(this, "PNRKalemList", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.itemsodeme = response.body.data;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },
        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
        }
      );
    },
    cariislemler1(kod) {
      
      let params = {
        Code: kod,
        SummaryInfoShow: false,
      };

      tool.http_post(this, "GetCurrent", params).then(
        (response) => {
          if (response.body.Status == true) {
            // if(response.body.data.Unvani2 != null){
            // this.odeme.CariKod.Unvan2 = response.body.data.Unvani2;
            // }

            if (response.body.data.FaturaBilgi != null) {
              this.odeme.CariKod.Adres1 = response.body.data.FaturaBilgi.Adres;
              this.odeme.CariKod.Adres2 = response.body.data.FaturaBilgi.Adres2;
              this.odeme.CariKod.VergiDairesi =
                response.body.data.FaturaBilgi.VergiDairesi;
              this.odeme.CariKod.VergiNo =
                response.body.data.FaturaBilgi.VergiNo;
              this.odeme.CariKod.TCKimlikNo =
                response.body.data.FaturaBilgi.TckimlikNo;
              this.odeme.CariKod.Ilce_Il =
                response.body.data.FaturaBilgi.IlceIl;
              this.odeme.CariKod.EfaturaKayitli = parseInt(
                response.body.data.EFaturaKayitli
              );
              this.odeme.CariKod.PerFirstName =
                response.body.data.FaturaBilgi.PerFirstName;
              this.odeme.CariKod.PerFamilyName =
                response.body.data.FaturaBilgi.PerFamilyName;
            }
            this.odeme.CariKod.EMail = response.body.data.Email;
            this.odeme.CariKod.id = response.body.data.Kod;
            this.odeme.CariKod.kod = response.body.data.Kod;
            this.odeme.CariKod.isim = response.body.data.Unvan;
            this.odeme.CariKod.tip = 0;
      
         
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },

        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
        }
      );
    },
    cariislemler(a) {
      let params = {
        Code: a,
        SummaryInfoShow: false,
      };

      tool.http_post(this, "GetCurrent", params).then(
        (response) => {
          if (response.body.Status == true) {
            if (this.odeme.OdemeTipi == 0) {
              this.odeme.NakitBilgi.KarsiCari.Unvan2 =
                response.body.data.Unvani2;
              this.odeme.NakitBilgi.KarsiCari.Adres1 =
                response.body.data.FaturaBilgi.Adres;
              this.odeme.NakitBilgi.KarsiCari.Adres2 =
                response.body.data.FaturaBilgi.Adres2;
              this.odeme.NakitBilgi.KarsiCari.VergiDairesi =
                response.body.data.FaturaBilgi.VergiDairesi;
              this.odeme.NakitBilgi.KarsiCari.VergiNo =
                response.body.data.FaturaBilgi.VergiNo;
              this.odeme.NakitBilgi.KarsiCari.TCKimlikNo =
                response.body.data.FaturaBilgi.TckimlikNo;
              this.odeme.NakitBilgi.KarsiCari.Ilce_Il =
                response.body.data.FaturaBilgi.IlceIl;
              this.odeme.NakitBilgi.KarsiCari.EfaturaKayitli = parseInt(
                response.body.data.EFaturaKayitli
              );
              this.odeme.NakitBilgi.KarsiCari.PerFirstName =
                response.body.data.FaturaBilgi.PerFirstName;
              this.odeme.NakitBilgi.KarsiCari.PerFamilyName =
                response.body.data.FaturaBilgi.PerFamilyName;
              this.odeme.NakitBilgi.KarsiCari.EMail = response.body.data.Email;
              this.odeme.NakitBilgi.KarsiCari.id = this.cariKodu.KarsiCari.id;
              this.odeme.NakitBilgi.KarsiCari.kod = this.cariKodu.KarsiCari.kod;
              this.odeme.NakitBilgi.KarsiCari.isim = this.cariKodu.KarsiCari.isim;
              this.odeme.NakitBilgi.KarsiCari.tip = 0;
            } else {
              this.odeme.NakitBilgi.KarsiCari.Unvan2 = null;
              this.odeme.NakitBilgi.KarsiCari.Adres1 = null;
              this.odeme.NakitBilgi.KarsiCari.Adres2 = null;
              this.odeme.NakitBilgi.KarsiCari.VergiDairesi = null;
              this.odeme.NakitBilgi.KarsiCari.VergiNo = null;
              this.odeme.NakitBilgi.KarsiCari.TCKimlikNo = null;
              this.odeme.NakitBilgi.KarsiCari.Ilce_Il = null;
              this.odeme.NakitBilgi.KarsiCari.EfaturaKayitli = null;
              this.odeme.NakitBilgi.KarsiCari.PerFirstName = null;
              this.odeme.NakitBilgi.KarsiCari.PerFamilyName = null;
              this.odeme.NakitBilgi.KarsiCari.EMail = null;

              this.odeme.NakitBilgi.KarsiCari.id = null;
              this.odeme.NakitBilgi.KarsiCari.kod = null;
              this.odeme.NakitBilgi.KarsiCari.isim = null;
              this.odeme.NakitBilgi.KarsiCari.tip = 0;
            }

            if (this.odeme.OdemeTipi == 1) {
              this.odeme.KrediKartBilgi.KarsiCari.Unvan2 =
                response.body.data.Unvani2;
              this.odeme.KrediKartBilgi.KarsiCari.Adres1 =
                response.body.data.FaturaBilgi.Adres;
              this.odeme.KrediKartBilgi.KarsiCari.Adres2 =
                response.body.data.FaturaBilgi.Adres2;
              this.odeme.KrediKartBilgi.KarsiCari.VergiDairesi =
                response.body.data.FaturaBilgi.VergiDairesi;
              this.odeme.KrediKartBilgi.KarsiCari.VergiNo =
                response.body.data.FaturaBilgi.VergiNo;
              this.odeme.KrediKartBilgi.KarsiCari.TCKimlikNo =
                response.body.data.FaturaBilgi.TckimlikNo;
              this.odeme.KrediKartBilgi.KarsiCari.Ilce_Il =
                response.body.data.FaturaBilgi.IlceIl;
              this.odeme.KrediKartBilgi.KarsiCari.EfaturaKayitli = parseInt(
                response.body.data.EFaturaKayitli
              );
              this.odeme.KrediKartBilgi.KarsiCari.PerFirstName =
                response.body.data.FaturaBilgi.PerFirstName;
              this.odeme.KrediKartBilgi.KarsiCari.PerFamilyName =
                response.body.data.FaturaBilgi.PerFamilyName;
              this.odeme.KrediKartBilgi.KarsiCari.EMail =
                response.body.data.Email;

              this.odeme.KrediKartBilgi.KarsiCari.id = this.cariKodu.KarsiCari.id;
              this.odeme.KrediKartBilgi.KarsiCari.kod = this.cariKodu.KarsiCari.kod;
              this.odeme.KrediKartBilgi.KarsiCari.isim = this.cariKodu.KarsiCari.isim;
              this.odeme.KrediKartBilgi.KarsiCari.tip = 0;
            } else {
              this.odeme.KrediKartBilgi.KarsiCari.Unvan2 = null;
              this.odeme.KrediKartBilgi.KarsiCari.Adres1 = null;
              this.odeme.KrediKartBilgi.KarsiCari.Adres2 = null;
              this.odeme.KrediKartBilgi.KarsiCari.VergiDairesi = null;
              this.odeme.KrediKartBilgi.KarsiCari.VergiNo = null;
              this.odeme.KrediKartBilgi.KarsiCari.TCKimlikNo = null;
              this.odeme.KrediKartBilgi.KarsiCari.Ilce_Il = null;
              this.odeme.KrediKartBilgi.KarsiCari.EfaturaKayitli = null;
              this.odeme.KrediKartBilgi.KarsiCari.PerFirstName = null;
              this.odeme.KrediKartBilgi.KarsiCari.PerFamilyName = null;
              this.odeme.KrediKartBilgi.KarsiCari.EMail = null;

              this.odeme.KrediKartBilgi.KarsiCari.id = null;
              this.odeme.KrediKartBilgi.KarsiCari.kod = null;
              this.odeme.KrediKartBilgi.KarsiCari.isim = null;
              this.odeme.KrediKartBilgi.KarsiCari.tip = 0;
            }
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },

        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
        }
      );
    },
    NakitBilgiTemizle() {
      this.odeme.NakitBilgi.KarsiCari.Unvan2 = null;
      this.odeme.NakitBilgi.KarsiCari.Adres1 = null;
      this.odeme.NakitBilgi.KarsiCari.Adres2 = null;
      this.odeme.NakitBilgi.KarsiCari.VergiDairesi = null;
      this.odeme.NakitBilgi.KarsiCari.VergiNo = null;
      this.odeme.NakitBilgi.KarsiCari.TCKimlikNo = null;
      this.odeme.NakitBilgi.KarsiCari.Ilce_Il = null;
      this.odeme.NakitBilgi.KarsiCari.EfaturaKayitli = null;
      this.odeme.NakitBilgi.KarsiCari.PerFirstName = null;
      this.odeme.NakitBilgi.KarsiCari.PerFamilyName = null;
      this.odeme.NakitBilgi.KarsiCari.EMail = null;
      this.odeme.NakitBilgi.KarsiCariAciklama = null;

      this.odeme.NakitBilgi.KarsiCari.id = null;
      this.odeme.NakitBilgi.KarsiCari.kod = null;
      this.odeme.NakitBilgi.KarsiCari.isim = null;
      this.odeme.NakitBilgi.KarsiCari.tip = 0;
    },
    KrediKartBilgiTemizle() {
      this.odeme.KrediKartBilgi.KarsiCari.Unvan2 = null;
      this.odeme.KrediKartBilgi.KarsiCari.Adres1 = null;
      this.odeme.KrediKartBilgi.KarsiCari.Adres2 = null;
      this.odeme.KrediKartBilgi.KarsiCari.VergiDairesi = null;
      this.odeme.KrediKartBilgi.KarsiCari.VergiNo = null;
      this.odeme.KrediKartBilgi.KarsiCari.TCKimlikNo = null;
      this.odeme.KrediKartBilgi.KarsiCari.Ilce_Il = null;
      this.odeme.KrediKartBilgi.KarsiCari.EfaturaKayitli = null;
      this.odeme.KrediKartBilgi.KarsiCari.PerFirstName = null;
      this.odeme.KrediKartBilgi.KarsiCari.PerFamilyName = null;
      this.odeme.KrediKartBilgi.KarsiCari.EMail = null;
      this.odeme.KrediKartBilgi.KarsiCariAciklama = null;
      this.odeme.KrediKartBilgi.FirmaKrediKartli = false;

      this.odeme.KrediKartBilgi.KarsiCari.id = null;
      this.odeme.KrediKartBilgi.KarsiCari.kod = null;
      this.odeme.KrediKartBilgi.KarsiCari.isim = null;
      this.odeme.KrediKartBilgi.KarsiCari.tip = 0;
    },
    HavaleTemizle() {
      this.odeme.HavaleBilgi.Banka = null;
      this.odeme.HavaleBilgi.Aciklama = null;
    },
    formTemizle() {
      this.cariKodu.KarsiCari.id = "";
      this.cariKodu.KarsiCari.isim = "";
      this.cariKodu.KarsiCari.kod = "";
      this.cariKodu.KarsiCari.isimAra = "";
      this.cariKodu.KarsiCariAciklama = "";

      this.odeme.OdemeTarihi = helpers.getDateNow();
      this.para.kur = 1;
      this.para.paraBirimi = "TL";
      this.odeme.OdemeTipi = 0;
      this.kalemdata = {
        PNR_No: null,
      };

      this.odeme.NakitBilgi.KarsiCari.Unvan2 = null;
      this.odeme.NakitBilgi.KarsiCari.Adres1 = null;
      this.odeme.NakitBilgi.KarsiCari.Adres2 = null;
      this.odeme.NakitBilgi.KarsiCari.VergiDairesi = null;
      this.odeme.NakitBilgi.KarsiCari.VergiNo = null;
      this.odeme.NakitBilgi.KarsiCari.TCKimlikNo = null;
      this.odeme.NakitBilgi.KarsiCari.Ilce_Il = null;
      this.odeme.NakitBilgi.KarsiCari.EfaturaKayitli = null;
      this.odeme.NakitBilgi.KarsiCari.PerFirstName = null;
      this.odeme.NakitBilgi.KarsiCari.PerFamilyName = null;
      this.odeme.NakitBilgi.KarsiCari.EMail = null;
      this.odeme.NakitBilgi.KarsiCariAciklama = null;
      this.odeme.NakitBilgi.KarsiCari.id = null;
      this.odeme.NakitBilgi.KarsiCari.kod = null;
      this.odeme.NakitBilgi.KarsiCari.isim = null;
      this.odeme.NakitBilgi.KarsiCari.tip = 0;

      this.odeme.KrediKartBilgi.KarsiCari.Unvan2 = null;
      this.odeme.KrediKartBilgi.KarsiCari.Adres1 = null;
      this.odeme.KrediKartBilgi.KarsiCari.Adres2 = null;
      this.odeme.KrediKartBilgi.KarsiCari.VergiDairesi = null;
      this.odeme.KrediKartBilgi.KarsiCari.VergiNo = null;
      this.odeme.KrediKartBilgi.KarsiCari.TCKimlikNo = null;
      this.odeme.KrediKartBilgi.KarsiCari.Ilce_Il = null;
      this.odeme.KrediKartBilgi.KarsiCari.EfaturaKayitli = null;
      this.odeme.KrediKartBilgi.KarsiCari.PerFirstName = null;
      this.odeme.KrediKartBilgi.KarsiCari.PerFamilyName = null;
      this.odeme.KrediKartBilgi.KarsiCari.EMail = null;
      this.odeme.KrediKartBilgi.KarsiCariAciklama = null;
      this.odeme.KrediKartBilgi.FirmaKrediKartli = false;
      this.odeme.KrediKartBilgi.KarsiCari.id = null;
      this.odeme.KrediKartBilgi.KarsiCari.kod = null;
      this.odeme.KrediKartBilgi.KarsiCari.isim = null;
      this.odeme.KrediKartBilgi.KarsiCari.tip = 0;
      this.odeme.KrediKartBilgi.KartNo = null;
      this.odeme.KrediKartBilgi.KartAdi = null;
      this.odeme.KrediKartBilgi.KartTipi = null;
      this.odeme.KrediKartBilgi.Banka = null;
      this.odeme.KrediKartBilgi.Taksit = 0;
      this.odeme.KrediKartBilgi.PosKodu = null;
      this.odeme.KrediKartBilgi.PosTaksit = null;
      this.odeme.KrediKartBilgi.PuanTutari = 0;

      this.odeme.HavaleBilgi.Banka = null;
      this.odeme.HavaleBilgi.Aciklama = null;

      this.odeme.Tutar = 0;
      this.odeme.ParaBirimi = "TL";
      this.odeme.Kur = 1;
      this.odeme.SaticiOdemeIadesi = false;
      this.odeme.PNR_No = null;
      this.odeme.EvrakNo = null;
      this.odeme.Aciklama = null;
    },
    getparabirimi() {
      return helpers.getparabirimiDefault(this.para.paraBirimi);
    },
    taksitgetirtahsilat(v) {
      var tumliste = [];
      tumliste = this.bankapositems;
      tumliste.forEach((element) => {
        if (element.PosKodu == v) {
          this.taksitsayitahsilat = [];
          this.taksitsayitahsilat = element.Taksitler;
        }
      });
    },
    open(title, pnrno, data) {
      if (title == "ekle") {
        this.dialogbaslik = "Ödeme Ekle";
        this.PnrNo = pnrno;
        this.kaydetbuton = true;
        this.tahsilatguncellebuton = false;
        this.PNRKalemList();
        this.formTemizle();
      }

      if (title == "update") {
        this.dialogbaslik = "Tahsilat Güncelle";
        this.yedekodeme = data;
        this.tahsilatguncellebuton = true;
        this.kaydetbuton = false;
        this.loadingvmodel = true;
        var _NakitBilgi = {
          KarsiCari: {
            Unvan2: null,
            Adres1: null,
            Adres2: null,
            VergiDairesi: null,
            VergiNo: null,
            TCKimlikNo: null,
            Ilce_Il: null,
            EfaturaKayitli: null,
            PerFirstName: null,
            PerFamilyName: null,
            EMail: null,
            id: null,
            kod: null,
            isim: null,
            tip: null,
          },
          KarsiCariAciklama: null,
        };
        var _KrediKartBilgi = {
          KarsiCari: {
            Unvan2: null,
            Adres1: null,
            Adres2: null,
            VergiDairesi: null,
            VergiNo: null,
            TCKimlikNo: null,
            Ilce_Il: null,
            EfaturaKayitli: null,
            PerFirstName: null,
            PerFamilyName: null,
            EMail: null,
          },
          KarsiCariAciklama: null,
          FirmaKrediKartli: false,
          KartNo: null,
          KartAdi: null,
          KartTipi: null,
          Banka: null,
          Taksit: 0,
        };
        var _HavaleBilgi = {
          Banka: null,
          Aciklama: null,
        };
        var params = {
          Odeme: Object.assign({}, data),
          KalemInfoParaBirimi: data.DovizCinsi
        };
        tool.http_post(this, "SaticiOdemeLoad", params).then(
          (response) => {
            if (response.body.Status == true) {

              this.odeme = response.body.data; 
              this.para.kur = response.body.data.Kur;
              this.para.paraBirimi = response.body.data.ParaBirimi;
              if (response.body.data.KrediKartBilgi == null) {
                this.odeme.KrediKartBilgi = Object.assign({}, _KrediKartBilgi);
              }else{
                this.cariKodu.KarsiCariAciklama = response.body.data.KrediKartBilgi.KarsiCariAciklama;
                this.cariKodu.KarsiCari.id = response.body.data.KrediKartBilgi.KarsiCari.id;
                this.cariKodu.KarsiCari.isim = response.body.data.KrediKartBilgi.KarsiCari.isim;
                this.cariKodu.KarsiCari.kod = response.body.data.KrediKartBilgi.KarsiCari.kod;
              }
              if (response.body.data.HavaleBilgi == null) {
                this.odeme.HavaleBilgi = Object.assign({}, _HavaleBilgi);
              }
              if (response.body.data.NakitBilgi == null) {
                this.odeme.NakitBilgi = Object.assign({}, _NakitBilgi);
              }else{
                this.cariKodu.KarsiCariAciklama = response.body.data.NakitBilgi.KarsiCariAciklama;
                this.cariKodu.KarsiCari.id = response.body.data.NakitBilgi.KarsiCari.id;
                this.cariKodu.KarsiCari.isim = response.body.data.NakitBilgi.KarsiCari.isim;
                this.cariKodu.KarsiCari.kod = response.body.data.NakitBilgi.KarsiCari.kod;
              }


              this.kalemdata.PNR_No = response.body.data;

              this.cariislemler(response.body.data.CariKod.kod);

           
              var kalemParams = {
                PNR_No: response.body.data.PNR_No,
                IslemRef: response.body.data.IslemRef,
                SaticiTip: this.yedekodeme.SaticiTip.split("-")[0],
                TurOperatoru: {
                  YurtIci_YurtDisi: 0,
                  CariKod: null,
                  KDV: 0,
                  id: "0",
                  kod: null,
                  isim: null,
                  tip: 12,
                  intField: null,
                },
                Satici: {
                  YurtIci_YurtDisi: 0,
                  CariKod: response.body.data.CariKod.kod,
                  KDV: 0,
                  id: response.body.data.CariKod.id,
                  kod: response.body.data.CariKod.kod,
                  isim: response.body.data.CariKod.isim,
                  tip: response.body.data.CariKod.tip,
                  intField: response.body.data.CariKod.intField,
                },
                Donem1: this.yedekodeme.Donem1,
                Donem2: this.yedekodeme.Donem2,
                KalemMaliyet: response.body.data.KalemInfo.KalemMaliyet,
                MaliyetDoviz: 0,
                MaliyetParaBirimi: response.body.data.ParaBirimi,
                MasrafMerkezi: {
                  id: "0",
                  kod: null,
                  isim: null,
                  tip: 0,
                  intField: null,
                },
                KisiIsim: response.body.data.CariKod.isim,
                Komisyon: 0,
                KomisyonDoviz: 0,
                MaliyetKur: response.body.data.Kur,
                KdvOrani: 0,
                KdvTutari: 0,
              };
              this.itemsodeme = [kalemParams];
              this.loadingvmodel = false;
            } else {
              this.text1 = response.body.ErrorList[0];
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          },
          (response) => {
           this.text1 = $t('Error-Occured-Please-Try-Again')
            this.snackbar = true;
            this.loadingvmodel = false;
          }
        );

        this.taksitgetirtahsilat(this.odeme.P_CoKrediKartBanka);
      }

      this.tahsilatdialog = true;
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      var params = {
        CompanyCode: credentials.CoperSirketNo,
        PosCode: null,
        Search: null,
        Coper: true,
      };

      this.$http
        .post(auth.API_URL + "api/BankPos/List", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.bankapositems = response.body;
            this.progress = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-bankpos";
              this.progress = false;
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-bankpos";
              this.snackbar = true;
              this.progress = false;
            }
          }
        );

      this.$http
        .post(auth.API_URL + "api/Bank/List", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.itemsbanka = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
            }
          }
        );

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    odemekaydet: odemekaydet,
    tahsilatvalidate,
    tahsilatguncelle: tahsilatguncelle,
  },
  data() {
    return {
      disabledtest: false,
      timeout: null,
      PnrNo: null,
      defaultParaBirimi: "TL",

      kalemdata: {
        PNR_No: null,
      },
      searchsatilanbilet: null,
      headersodeme: [
        {
          text: "Satıcı Tip",
          value: "SaticiTip",
          width: "3%",
          align: "left",
        },
        {
          text: "Satıcı Ad",
          value: "Satici.isim",
          width: "30%",
          align: "left",
        },
        {
          text:  this.$t('Period-v2') + "1",
          value: "Donem1",
          width: "5%",
          align: "center",
        },

        {
          text: this.$t('Period-v2') + "2",
          value: "Donem2",
          width: "5%",
          align: "center",
        },
        {
          text: this.$t('Amount'),
          value: "KalemMaliyet",
          width: "5%",
          align: "right",
        },
        {
          text: this.$t('Currency-Amount'),
          value: "MaliyetDoviz",
          width: "5%",
          align: "right",
        },
        {
          text: this.$t('Currency-Unit'),
          value: "ParaBirimi",
          width: "5%",
          align: "center",
        },
        {
          text: "Satıcı Cari",
          value: "Satici.kod",
          width: "5%",
          align: "center",
        },
        {
          text: this.$t('Expense-Center-v2'),
          value: "MasrafMerkezi.kod",
          width: "5%",
          align: "center",
        },
        {
          text: this.$t('Name'),
          value: "KisiIsim",
          width: "5%",
          align: "left",
        },
      ],
      itemsodeme: [],

      loadingvmodel: false,
      validkredikarti: true,
      validkarsicari: true,
      validhavale: true,
      cariKodu: {
        KarsiCari: {
          id: null,
          isim: null,
          kod: null,
          isimAra: null,
        },
        KarsiCariAciklama: null,
      },

      odeme: {
        CariKod: {
          Unvan2: null,
          Adres1: null,
          Adres2: null,
          VergiDairesi: null,
          VergiNo: null,
          TCKimlikNo: null,
          Ilce_Il: null,
          EfaturaKayitli: null,
          PerFirstName: null,
          PerFamilyName: null,
          EMail: null,
          id: null,
          kod: null,
          isim: null,
          tip: null,
        },
        OdemeTarihi: null,
        OdemeTipi: 0,
        NakitBilgi: {
          KarsiCari: {
            Unvan2: null,
            Adres1: null,
            Adres2: null,
            VergiDairesi: null,
            VergiNo: null,
            TCKimlikNo: null,
            Ilce_Il: null,
            EfaturaKayitli: null,
            PerFirstName: null,
            PerFamilyName: null,
            EMail: null,
            id: null,
            kod: null,
            isim: null,
            tip: null,
          },
          KarsiCariAciklama: null,
        },
        KrediKartBilgi: {
          KarsiCari: {
            Unvan2: null,
            Adres1: null,
            Adres2: null,
            VergiDairesi: null,
            VergiNo: null,
            TCKimlikNo: null,
            Ilce_Il: null,
            EfaturaKayitli: null,
            PerFirstName: null,
            PerFamilyName: null,
            EMail: null,
          },
          KarsiCariAciklama: null,
          FirmaKrediKartli: false,
          KartNo: null,
          KartAdi: null,
          KartTipi: null,
          Banka: null,
          Taksit: 0,
        },
        HavaleBilgi: {
          Banka: null,
          Aciklama: null,
        },

        Tutar: 0,
        ParaBirimi: "TL",
        Kur: 1,
        SaticiOdemeIadesi: false,
        PNR_No: null,

        Aciklama: null,
      },

      yedekodeme: {},
      para: {
        paraBirimi: "TL",
        kur: 1,
      },
      sirketlist: [],
      karttipi: [
        {
          id: "MASTER",
          text: "Master Card",
        },
        {
          id: "VISA",
          text: "VISA",
        },
        {
          id: "AmEx",
          text: "American Express",
        },
      ],
      odemeItems: [
        {
          text: "Nakit",
          value: 0,
        },
        {
          text: this.$t('Credit-Card'),
          value: 1,
        },
        {
          text: this.$t('Transfer-v3'),
          value: 2,
        },
      ],

      valid: true,
      alertshow: false,
      alertmodel: true,
      tahsilatbakiyem: 0,
      dialogbaslik: "",
      resolve: null,
      kaydetbuton: false,
      tahsilatguncellebuton: false,
      k: null,
      doviztipi: [],
      reject: null,
      bankapositems: [],
      itemsbanka: [],
      statecaritahsilat: [],
      itemsevraktipi: [],
      tahsilatdialog: false,
      text1: null,
      searchcaritahsilat: "",
      taksitsayitahsilat: [],
      loading: false,
      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeoutSnackbar: 6000,
    };
  },

  watch: {
    "para.paraBirimi": function (val){
      if(this.kaydetbuton){
        this.PNRKalemList();
      }else{
        //this.open("update",this.kalemdata.PNR_No,this.yedekodeme);
      }
        
    },
    searchcaritahsilat(val) {
      val && this.carigetir2(val);
    },
    "cariKodu.KarsiCari.kod": function (val) {
      if (val != null && val != "") {
        this.cariislemler(val);
      }
    },
    kalemdata: function (val) {
      if (val.PNR_No != null) {
        // if (val.TurOperatoru.kod != null && val.TurOperatoru.kod != "") {
        //   this.cariislemler1(val.TurOperatoru.CariKod);
        // } else {
        //   if (val.Satici.CariKod != null && val.Satici.CariKod != "") {
        //     this.cariislemler1(val.Satici.CariKod);
        //   } else {
        //   }
        // }
      }
    },
  },
  mounted() {},
};

function tahsilatvalidate() {
  if (this.$refs.formTahsilat.validate()) {
    if (this.odeme.Tutar > 0) {
      this.odeme.ParaBirimi = this.para.paraBirimi;
      this.odeme.Kur = this.para.kur;
      this.odeme.PNR_No = this.kalemdata.PNR_No;
      this.odeme.IslemRef = this.kalemdata.IslemRef;

      if (this.odeme.OdemeTipi == 0) {
        this.odeme.NakitBilgi.KarsiCariAciklama = this.cariKodu.KarsiCariAciklama;

        this.odemekaydet();
        // if (this.$refs.formkarsicari.validate()) {
        // }
      }

      if (this.odeme.OdemeTipi == 1) {
        this.odeme.KrediKartBilgi.KarsiCariAciklama = this.cariKodu.KarsiCariAciklama;

        // if (this.$refs.formkarsicari.validate()) {

        if (this.$refs.formkredikarti.validate()) {
          this.odemekaydet();
        }

        // }
      }

      if (this.odeme.OdemeTipi == 2) {
        // if (this.$refs.formhavale.validate()) {
        this.odemekaydet();
        // }
      }

      if (this.odeme.OdemeTipi == 3) {
        this.odeme.SanalPosBilgi.KarsiCariAciklama = this.cariKodu.KarsiCariAciklama;
        if (this.$refs.formkredikarti.validate()) {
          this.odemekaydet();
        }
      }
    } else {
      this.text1 = this.$t('Price-Must-be-Greater-than-zero');
      this.snackbar = true;
    }
  }
}

function odemekaydet() {
  if (this.odeme.OdemeTipi == 0) {
    this.KrediKartBilgiTemizle();
    this.HavaleTemizle();
  } else if (this.odeme.OdemeTipi == 1) {
    this.NakitBilgiTemizle();
    this.HavaleTemizle();
  } else {
    this.NakitBilgiTemizle();
    this.KrediKartBilgiTemizle();
  }

  if (this.kalemdata.TurOperatoru.CariKod != null && this.kalemdata.TurOperatoru.CariKod != "") {
    this.odeme.CariKod.kod = this.kalemdata.TurOperatoru.CariKod;
    this.odeme.CariKod.id = this.kalemdata.TurOperatoru.id;
    this.odeme.CariKod.isim =  this.kalemdata.TurOperatoru.isim;
    this.odeme.CariKod.tip = this.kalemdata.TurOperatoru.tip;
  } else {
    this.odeme.CariKod.kod = this.kalemdata.Satici.CariKod;
    this.odeme.CariKod.id = this.kalemdata.Satici.id;
    this.odeme.CariKod.isim =  this.kalemdata.Satici.isim;
    this.odeme.CariKod.tip = this.kalemdata.Satici.tip;
  }


  var prm = this.odeme;
  this.loadingvmodel = true;
  tool.http_post(this, "SaticiOdemesiEkle", prm).then(
    (response) => {
      if (response.body.Status == true) {
        this.val.itemsodeme = response.body.data.OdemeListesi;
        this.val.ToplamIade = response.body.data.ToplamIade;
        this.val.ToplamMaliyet = response.body.data.ToplamMaliyet;
        this.val.ToplamOdeme = response.body.data.ToplamOdeme;
        this.resolve(true);
        this.loadingvmodel = false;
        this.tahsilatdialog = false;
      } else {
        this.loadingvmodel = false;
        this.text1 = response.body.ErrorList[0];
        this.snackbar = true;
      }
    },
    (response) => {
      this.loadingvmodel = false;
      this.status = tool.responseToStatus(response);
    }
  );
}

function beforeMount() {}

function tahsilatguncelle() {
  if (this.$refs.formTahsilat.validate()) {
    this.loadingvmodel = true;

    if (this.kalemdata.PNR_No.KalemInfo.TurOperatoru.kod != null && this.kalemdata.PNR_No.KalemInfo.TurOperatoru.kod != "") {
      this.odeme.CariKod.kod = this.kalemdata.PNR_No.KalemInfo.TurOperatoru.CariKod;
    } else {
      this.odeme.CariKod.kod = this.kalemdata.PNR_No.KalemInfo.Satici.CariKod;
    }

    this.odeme.ParaBirimi = this.para.paraBirimi;
    this.odeme.Kur = this.para.kur;
    var paramsUpdate = {
      MevcutOdeme: Object.assign({}, this.yedekodeme),
    };

        paramsUpdate = Object.assign(paramsUpdate, this.odeme);

     if (paramsUpdate.MevcutOdeme.Evraktipi == "NK") {
        this.odeme.NakitBilgi.KarsiCariAciklama = this.cariKodu.KarsiCariAciklama;
    }else if(paramsUpdate.MevcutOdeme.Evraktipi == "KR"){
        this.odeme.KrediKartBilgi.KarsiCariAciklama = this.cariKodu.KarsiCariAciklama
    }


    tool.http_post(this, "SaticiOdemeUpdate", paramsUpdate).then(
      (response) => {

        if (response.body.Status == true) {
        this.resolve(true);
        this.tahsilatdialog = false;
        this.loadingvmodel = false;
        }else{
              this.tahsilatdialog = false;
              this.snackbar = true;
              this.text1 = response.body.ErrorList[0];
              this.loadingvmodel = false;

        }
      },
      (response) => {
        this.status = tool.responseToStatus(response);
        this.loadingvmodel = false;
      }
    );


  }
}
</script>